
export const processIconWidgetTemplate = ( iconCode: number, iconSize: string, iconSet: string,  forecastIconImageUrl: string ): string => {
    let imgSource: string  = forecastIconImageUrl;
    imgSource = imgSource?.replace('{iconSet}', iconSet);
    imgSource = imgSource?.replace('{iconCode}', `${iconCode}`);
    imgSource = imgSource?.replace('{iconSize}', iconSize);
    return imgSource;
};

export const getUrlFromResponse = (response: any): string =>
{
    const resource = response.Resources ? response.Resources[0] : response.rs[0];
    let url = resource.Url ? resource.Url : resource.u;
    const parameters = resource.Parameters ? resource.Parameters : resource.ps;

    for (let index = 0; index < parameters.length; index++) {
        url = `${url}${index==0 ? '?' : '&'}${parameters[index].Key 
            ? parameters[index].Key 
            : parameters[index].k}=${parameters[index].Value ? parameters[index].Value : parameters[index].v}`;
    }
    return url;
};